<template>
<div class="animated fadeIn">
  <div class="splash" v-if="!preloadDone">
    <div class="container  d-flex h-100">
      <div class="row justify-content-center text-primary w-100 align-self-center text-white">
        <i class="fa fa-spin fa-spinner"></i>
      </div>
    </div>
  </div>
  <div class="container mt-3" v-if="preloadDone">
    <div role="tablist" class="oportunity">
      <b-card no-body class="mb-1" v-for="result in results.results" :key="result.code">
        <b-card-header header-tag="header" class="p-3" role="tab">
        <b-row>
          <b-col md="6"><b-btn variant="link" v-b-toggle="'accordion-' + result.code" >{{ result.name }}</b-btn></b-col>
          <!--<<b-col md="2">Valor Shared: <span class="value">{{ result.value_shared | currency({fractionCount:1, symbol:'€'}) }}</span></b-col>-->
          <b-col md="3">Valor UFS: <span class="value">{{ result.value_ufs | currency({fractionCount:2, symbol:'€'}) }}</span></b-col>
          <!--<b-col md="2">Valor: <span class="value">{{ result.value | currency({fractionCount:1, symbol:'€'}) }}</span></b-col>-->
          <b-col md="3">Cumprem: <span class="value">{{ result.ok | currency({fractionCount:0, symbol:''}) }}</span></b-col>
        </b-row>
        </b-card-header>
        <b-collapse :id="'accordion-' + result.code" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-table responsive stacked="sm" :striped="true" :fields="resultFields" :items="result.results" :sort-by="value_ufs" :sort-desc="true">
              <template v-slot:cell(name)="data" >
                {{ data.item.name }}
              </template>
              <template v-slot:cell(codle)="data" >
                {{ data.item.codle }}
              </template>

              <template v-slot:cell(value_ufs)="data" >
                {{ data.item.value_ufs | currency({fractionCount:2, symbol:'€'}) }}
              </template>
              <!--<template v-slot:cell(value_shared)="data" >
                {{ data.item.value_shared | currency({fractionCount:1, symbol:'€'}) }}
              </template>-->
              <!--<template v-slot:cell(value)="data" >
                {{ data.item.value | currency({fractionCount:1, symbol:'€'}) }}
              </template>-->
              <template v-slot:cell(ok)="data" >
                {{ data.item.ok == '1'?'Sim':'Não' }}
              </template>

            </b-table>
          </b-card-body>
        </b-collapse>
      </b-card>
      <b-card no-body class="mb-1" v-for="result in results.cha_results" :key="result.code">
        <b-card-header header-tag="header" header-bg-variant="info" class="p-3" >
        <b-row>
          <b-col md="6"><span class="name">{{ result.name }}</span></b-col>
          <!--<b-col md="2">Valor Shared: <span class="value">{{ result.value_shared | currency({fractionCount:1, symbol:'€'}) }}</span></b-col>-->
          <b-col md="3">Valor UFS: <span class="value">{{ result.value_ufs | currency({fractionCount:2, symbol:'€'}) }}</span></b-col>
          <!--<b-col md="2">Valor: <span class="value">{{ result.value | currency({fractionCount:1, symbol:'€'}) }}</span></b-col>-->
          <b-col md="3">Cumprem: <span class="value">{{ result.ok | currency({fractionCount:0, symbol:''}) }}</span></b-col>
        </b-row>
        </b-card-header>
      </b-card>
      <b-card no-body class="mb-1" >
        <b-card-header header-tag="header" header-bg-variant="info" class="p-3" >
        <b-row>
          <b-col md="6"><span class="name">{{ results.national.name }}</span></b-col>
          <!--<b-col md="2">Valor Shared: <span class="value">{{ results.national.value_shared | currency({fractionCount:1, symbol:'€'}) }}</span></b-col>-->
          <b-col md="3">Valor UFS: <span class="value">{{ results.national.value_ufs | currency({fractionCount:2, symbol:'€'}) }}</span></b-col>
          <!--<b-col md="2">Valor: <span class="value">{{ results.national.value | currency({fractionCount:1, symbol:'€'}) }}</span></b-col>-->
          <b-col md="3">Cumprem: <span class="value">{{ results.national.ok | currency({fractionCount:0, symbol:''}) }}</span></b-col>
        </b-row>
        </b-card-header>
      </b-card>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'Profile',
  data() {
    return {
      preloadDone: false,
      showPrizes: false,
      results: {},
      resultFields: [
        { key: 'name', label: 'Nome', sortable: true },
        { key: 'codle', label: 'Codle', sortable: true },
        /* { key: 'value_shared', label: 'Valor Shared', sortable: true, width: '120px' }, */
        { key: 'value_ufs', label: 'Valor UFS', sortable: true, width: '120px' },
        /* { key: 'value', label: 'Valor', sortable: true, width: '120px' }, */
        { key: 'ok', label: 'Cumpre', sortable: true, width: '120px' }
      ]
    }
  },
  methods: {

  },
  created() {
    var that = this
    var user = this.$auth.user()
    console.log(user)
    this.axios.get('stars/oportunities/7').then(response => {
      that.results = response.data.data
      that.preloadDone = true
    })
  }
}
</script>



// WEBPACK FOOTER //
// oportunity.vue?4b87b2c9